import ModelUtil from '@leverege/model-util';
import ResponsiveModel from "../../responsive/ResponsiveModel.js";
const TYPE = 'molten.dataViewers.history.HistoryViewModel';
function create(model = null) {
  return {
    ...ResponsiveModel.create(model),
    type: TYPE,
    options: {
      perPage: 100,
      range: 'last7Days',
      queryModes: {
        targeted: true,
        selected: false,
        all: false
      },
      isForItem: false,
      density: 'sparse',
      condition: null,
      order: null
    },
    perPageEditable: true,
    allPages: false,
    allowExpandedView: null
  };
}
const methods = {
  ...ModelUtil.createAllMap('options/queryModes', 'QueryMode', 'QueryModes')
};
export default {
  ...ResponsiveModel,
  TYPE,
  create,
  ...ModelUtil.createAllValue('options/perPage', 'perPage'),
  ...ModelUtil.createAllValue('options/range', 'range'),
  ...ModelUtil.createAllValue('options/condition', 'condition'),
  ...ModelUtil.createAllValue('options/order', 'order'),
  ...ModelUtil.createAllValue('options/density', 'density'),
  ...ModelUtil.createAllValue('model'),
  ...ModelUtil.createAllValue('isForItem'),
  ...ModelUtil.createAllValue('perPageEditable', 'perPageEditable', null, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('allPages'),
  ...ModelUtil.createAllValue('allowExpandedView', 'AllowExpandedView'),
  getQueryMode: methods.getQueryMode,
  getQueryModes: methods.getQueryModes,
  setQueryModes: methods.setQueryModes,
  setQueryMode(model, itemKey, item) {
    let nModel = methods.setQueryMode(model, itemKey, item);
    switch (itemKey) {
      case 'targeted':
      case 'selected':
        {
          const queryModes = methods.getQueryModes(nModel);
          if (queryModes.all && item === true) {
            nModel = methods.setQueryMode(nModel, 'all', false);
          }
          break;
        }
      case 'all':
        nModel = methods.setQueryModes(model, {
          all: item,
          targeted: false,
          selected: false
        });
        break;
      default:
        return model;
    }
    if (hasNoMode(nModel)) {
      nModel = methods.setQueryMode(nModel, 'targeted', true);
    }
    return nModel;
  }
};
function hasNoMode(model) {
  const modes = methods.getQueryModes(model);
  const values = Object.values(modes);
  for (let i = 0; i < values.length; i++) {
    if (values[i] === true) {
      return false;
    }
  }
  return true;
}